import { inject, observer } from 'mobx-react';
import { ReactComponent as Check } from '../../svg/check-circle.svg'
import { ReactComponent as WorldIcon } from '../../svg/planet-icon.svg'
import React from 'react'
import PermissionsDropdown from '../Inputs/PermissionsDropdown';
import { autorun } from 'mobx';
import ModalWrapper from '../Inputs/ModalWrapper';
import CustomModalHeader from '../Inputs/CustomModalHeader';

@inject('workAreaStore', 'store') @observer

class ShareMenu extends React.Component {

  constructor(props){
    super(props)
    this.state = {
      copied: false,
      showLink: true,
      updated: false,
      shareTo: {
        value: '',
        option: {
          value: 'edit',
          label: 'Can edit'
        }
      },
      publicShare: {
        link: '',
        option: {
          value: 'view',
          label: 'Can view'
        }
      },
      inviteValue: '',
      inviteSent: false,
      shareToggle: false
    }
  }

  componentDidMount(){
    if(!this.props.store.teamDetails._id){
      this.props.store.fetchTeam()
    }
    const { workAreaStore, store } = this.props
    const p = workAreaStore.publicPermissions
    const publicShare = {
      link: window.location.href,
      option: {
        value: p,
        label: `Can ${p}`
      }
    }
    if(p !== 'edit'){
      publicShare.link += '/view'
    }
    this.setState({ publicShare, showLink: p !== 'none', shareToggle: store.sharedWithTeam })
  }

  handleSearch(e){
    const { value } = e.target
    const shareTo = {
      ...this.state.shareTo,
      value: value
    }
    this.setState({ shareTo })
    this.props.store.searchTeamMember(value)
  }

  setShareTo(data){
    const to = { ...this.state.shareTo }
    to.option = data
    this.setState({ shareTo: to })
  }

  setMemberShare(data, id){
    this.props.store.editMemberRole(id, data)
  }

  getMemberDetails(name, email, id, accessLevel){
    if(!name){
      return <div />
    }
    const [first, last] = name.split(' ')
    let initials = first.slice(0, 1)
    if(last){
      initials += last.slice(0, 1)
    }
    if(!accessLevel){
      return <div />
    }
    const className = `member-display row`
    return (
      <div className='col-12' key={id}>
        <div className={className}>
          <div className='col-2'>
            <div className='profile-icon'>
              {initials.toUpperCase()}
            </div>
          </div>
          <div className='col-8 details-meta'>
            <span className='name'>{name}</span>
            <span className='email'>{email}</span>
          </div>
          <div className={accessLevel === 'owner' ? 'col-2 access owner' : 'col-2 access'}>
            {
              <span className='access-type'>{accessLevel}</span>
            }
          </div>
        </div>
      </div>
    )
  }

  setPublicShare(data){
    this.props.workAreaStore.updateDesignPublicPermissions(data.value)
  }

  copyLink(e){
    e.preventDefault()
    const node = document.createElement('textarea')
    node.classList.add('temp-copy-input')
    node.style = 'z-index: -1; position: absolute; left: 0; top: 0;'
    node.textContent = this.state.publicShare.link
    document.body.appendChild(node)
    const area = document.querySelector('.temp-copy-input')
    area.focus()
    area.select()
    document.execCommand('copy')
    area.remove()
    this.setState({ copied: true })
    setTimeout(() => {
      this.setState({ copied: false })
    }, 5000)
  }

  handleChange(e){
    const { name, value } = e.target
    this.setState({ [name]: value })
  }

  getPublicDetails(){
    const { publicShare, copied, showLink } = this.state
    const text = showLink ? 'Anyone with the link' : 'Design public access:'
    return (
      <>
        <div className='col-1'>
          <WorldIcon style={{ marginBottom: '2px', marginLeft: '15px' }} />
        </div>
        <div className='col-7'>
          <span className='link-description'>
            {text} {' '}
            {
              copied ? (
                <Check className='checkmark' />
              )
              :
              (
                showLink ? (
                  <button className='btn btn-download' onClick={(e) => this.copyLink(e)}>
                    Copy link
                  </button>
                )
                :
                undefined
              )
            }
          </span>
        </div>
        <div className='col-4'>
          <PermissionsDropdown
            available={['view']}
            showNone={true}
            activeValue={publicShare.option}
            selectPermission={data => this.setPublicShare(data)}
          />
        </div>
      </>
    )
  }

  close(){
    const { store } = this.props
    if(store.auth){
      store.toggleShare(!this.props.store.modals.shareOpen, this.props.workAreaStore.designId)
    }else{
      console.log('show modal')
    }
  }

  handleTeamShare(e, value){
    this.setState({ shareToggle: value })
    this.props.store.shareWithTeam(value)
  }

  getTeamShareRow(sharedWithTeam, teamDetails, activeTeamPlan = true){
    if(teamDetails && teamDetails.members){
      return (
        <div className='share-details pl-0 pr-0 pb-2'>
          <h6 className='pl-3'>Your team members</h6>
          {
            teamDetails.members.map(member => {
              const { _id, role, user: { firstname, lastname, email } } = member
              return this.getMemberDetails(`${firstname} ${lastname}`, email, _id, role)
            })
          }
          {
            activeTeamPlan ? (
              <div className='share-details__toggle-wrapper'>
                <span className='share-details__toggle-wrapper__text d-block w-100'>
                  {
                    sharedWithTeam ? 'This design is shared with your team members' : 'Share this design with your team'
                  }
                </span>
                <input 
                  checked={this.state.shareToggle}
                  onChange={e => this.handleTeamShare(e, !sharedWithTeam)}
                  type="checkbox"
                  className='toggle'
                  id="team-toggle"
                />
                <label htmlFor="team-toggle" className='toggle-label'></label>
              </div>
            )
            :
            (
            <div className='alert secondary-alert team-alert flex-alert'>
              <span>Your team plan is expired</span>
              <a className='team-alert__link' href={`${window.location.origin}/dashboard/team`} target="_blank">Click here to reactivate your team plan</a>
            </div>
            )
          }
        </div>
      )
    }else{
      return <div />
    }
  }

  getTeamPromo(){
    return (
      <div className='share-details promo'>
        <span className='promo__heading'>
          Want to share your template with your team?
        </span>
        <a className='text-secondary promo__link' href="/dashboard/team" target="_blank">
          Create a team account
        </a>
      </div>
    )
  }

  render(){
    const { modals: { shareOpen }, sharedWithTeam, auth, teamDetails, isTeam, activeTeamPlan } = this.props.store
    const { designRoles, emptySaved, pages } = this.props.workAreaStore
    if(!shareOpen){
      return <div />
    }
    const showEmpty = auth && emptySaved && (pages.length === 0 || pages[0].layers.length === 0)
    return (
      <ModalWrapper
        close={this.close.bind(this)}
        modalClass={'share'}
      >
        <CustomModalHeader
          close={this.close.bind(this)}
          title={'Share'}
          headerClass={'share-menu__h'}
        />
        <div 
          className='share-menu custom-dropdown-menu'
        >
            {
              showEmpty ? (
                <div className='share-menu__empty row mb-4'>
                  <div className='col-10 offset-1'>
                    <span className='empty'>
                      Design is empty
                    </span>
                    <span className='gray'>
                      Add some elements to your design to share it!
                    </span>
                  </div>
                </div>
              )
              :
              undefined
            }
            {
              auth && isTeam && !showEmpty ? (
                this.getTeamShareRow(sharedWithTeam, teamDetails, activeTeamPlan)
              )
              :
              undefined
            }
            {
              auth && !isTeam && !showEmpty ? (
                this.getTeamPromo()
              )
              :
              undefined
            }
          <div className='share-menu__form-group'>
            <div className='row share public-share no-gutters mt-2'>
              {
                this.getPublicDetails()
              }
            </div>
          </div>
        </div>
    </ModalWrapper>
    )
  }

}

export default ShareMenu